import { Grid } from '@material-ui/core'
import { Stack, Card } from '@mui/material'
import CustomTextField from 'components/Form/CustomTextField'
import ProgressButton from 'components/ProgressButton'
import { Formik, Form } from 'formik'
import React, { useMemo } from 'react'
import yup from 'schemas/yup'
import { FieldType } from './constants'

const EditSettingForm = ({ fields = [], values, isLoading = false, onSave }) => {
  const schema = useMemo(() => {
    const schemaObject = {}
    fields.forEach((item) => {
      if (item.type === FieldType.number) {
        schemaObject[item.id] = yup
          .number()
          .label(`${item.name}`)
          .required(`${item.name} is required`)
      } else if (item.type === FieldType.link) {
        schemaObject[item.id] = yup
          .string()
          .label(`${item.name}`)
          .url('Please enter a valid URL')
          .required(`${item.name} is required`)
      } else {
        schemaObject[item.id] = yup
          .string()
          .label(`${item.name}`)
          .trimmedRequired(`${item.name} is required`)
      }
    })
    return yup.object().shape(schemaObject)
  }, [fields])

  const initialValues = useMemo(
    () =>
      fields.reduce((acc, item) => {
        acc[item.id] = values[item.id]
        return acc
      }, {}),
    [fields]
  )

  const onSubmit = (values) => {
    onSave && onSave(values)
  }

  if (fields.length === 0) return null

  return (
    <Formik
      validationSchema={schema}
      initialValues={initialValues}
      enableReinitialize
      onSubmit={onSubmit}>
      {() => (
        <Form>
          <Card elevation={2} sx={{ padding: '1.5rem 1rem', borderRadius: '16px', mt: 1 }}>
            <Grid container spacing={3}>
              {fields?.map((item) => {
                return (
                  <Grid key={item.id} item {...item.gridColumn}>
                    <CustomTextField
                      label={item?.name}
                      name={item?.id}
                      type={item?.type === FieldType.number ? 'number' : 'text'}
                    />
                  </Grid>
                )
              })}
            </Grid>

            <Stack direction="row" gap={2} justifyContent="end" mt={1.5}>
              <ProgressButton
                type="submit"
                label="Save"
                variant="contained"
                color="primary"
                disabled={isLoading}
                inProgress={isLoading}
              />
            </Stack>
          </Card>
        </Form>
      )}
    </Formik>
  )
}

export default EditSettingForm
